import { Box } from "@govlaunch/web";
import React from "react";
import { ICardViewMode } from "~/src/components/collection/cardViewMode";
import { FormattedMessage } from "react-intl";

interface IBundleCollectionCardNewContentProps {
  viewMode: ICardViewMode;
}

export default function BundleCollectionCardNewContent({ viewMode }: IBundleCollectionCardNewContentProps) {
  return (
    <Box
      position="absolute"
      bottom={viewMode === ICardViewMode.Bundles ? "12px" : "8px"}
      left={viewMode === ICardViewMode.Bundles ? "12px" : "8px"}
      color="red.800"
      fontSize={["lg", "sm", "md", "md"]}
      fontWeight="semibold"
      maxWidth={viewMode === ICardViewMode.Bundles || viewMode === ICardViewMode.MyCollections ? "90px" : undefined}
    >
      &#x25B8; <FormattedMessage defaultMessage="New Content" id="6aSEZT" />
    </Box>
  );
}
